export default {
  main: {
    site_id: 18772993,
    title: 'PlayPal77',
    enableWorldCup: true,
    terminalId: 1,
    logoSize: 'extra-huge-with-height',
    isTicketsCheckable: true,
    enableMultipleTicketPay: true,
    enableTicketPopupFlow: true,
    enableTicketTimer: true,
    restrictedAdminPrintableTicketsCount: 5,
    hasDayFilter: true,
    enableHeaderAdminSection: true,
    enableKeyboardCatching: true,
    staffPassword: '0',
    showEventTypeFilter: true,
    resultPageVirtualsId: [150, 197, 209, 118, 54, 55, 31, 184, 181],
    availableLanguages: {
      '@replace': true,
      eng: {
        short: 'EN',
        name: 'Eng',
        order: 1,
      },
    },
    homeMediaSlides: [
      {
        type: 'slider1',
        path: 'betting/prematch/all',
      },
      {
        type: 'slider2',
        path: 'betting/prematch/all',
      },
      {
        type: 'slider3',
        path: 'betting/prematch/all',
      },
      {
        type: 'slider4',
        path: 'betting/prematch/all',
      },
      {
        type: 'slider5',
        path: 'betting/prematch/all',
      },
      {
        type: 'slider6',
        path: 'betting/prematch/all',
      },
    ],
    homeBannerSlides: [
      {
        fileType: 'png',
        path: 'betting/prematch/virtuals',
      },
    ],
  },
  splitScreen: {
    enabled: false,
  },
  verticalHome: {
    grid: [["shortpages"], ["slider"], ['comp'], ["populargames"], ["casinogames"]],
    gridColumns: "1fr",
    gridRows: "1.5fr 7fr 6fr 4fr",
    //gridRows: "1.17fr 3fr 1.6fr 8.4fr",
  },
  defaultTerminalParams: { pid: 18772993, tid: 39576, token: '2vjpLw==', currency: 'PHP' },
  routes: [
    {
      url: 'worldcup',
      name: 'FIFA World Cup',
      enabled: true,
      disableInHeader: true,
    },
    {
      url: 'betting/live/all',
      name: 'Live',
      type: 'live',
      enabled: true,
      icon: 'circle',
    },
    {
      url: 'betting/prematch/all',
      name: 'Sports',
      type: 'sportsBook',
      enabled: true,
      icon: 'casino-categories-Sportsbook',
    },
    {
      name: 'Casino',
      url: 'casino',
      type: 'casino',
      enabled: true,
      nestedItems: [
        {
          name: 'Casino',
          type: 'casino',
          url: 'casino',
          enabled: true,
          icon: 'casino-7',
        },
        {
          name: 'Live Casino',
          type: 'liveCasino',
          url: 'liveCasino',
          enabled: true,
          icon: 'casino-categories-LotteryGames',
        },
      ],
    },
    {
      url: 'betting/prematch/virtuals',
      name: 'Virtuals',
      type: 'virtuals',
      enabled: true,
      icon: 'casino-categories-VirtualBetting',
      children: [
        {
          name: 'Games',
          url: 'betting/prematch/virtuals',
          icon: '',
        },
        {
          name: 'Results',
          url: 'betting/virtual-results',
          icon: '',
        },
      ],
    },
    {
      id: 3269,
      url: "casino-game/37592",
      icon: "global-icon icon-aviator custom-icons aviator",
      className: "custom-button",
      name: "Aviator",
      enabled: true,
    },
    {
      url: 'betting/results',
      name: 'Results',
      type: 'results',
      enabled: true,
    },
    {
      url: 'tickets',
      name: 'Tickets',
      enabled: true,
    },
  ],
  lastTicketButtons: [
    {
      name: 'Bet tickets',
      type: 'betTicket',
      hideOnRestrictMode: false,
    },
    {
      name: 'Cash-out',
      type: 'cashoutTicket',
      hideOnRestrictMode: false,
    },
    {
      name: 'Pay-out',
      type: 'payoutTicket',
      hideOnRestrictMode: false,
    },
  ],
  betslip: {
    enableBookingBet: true,
    enableBookingId: true,
    bookingBetBalanceMaxLimit: 9999999,
    hidePlaceBetIfNotAuthorized: false,
    betDetailsOrder: [
      'total_odd',
      'total_stake',
      'possible_win',
      'bonus',
      'tax_on_return_or_profit',
      'total_win',
    ],
  },
};
